import { Image, Platform } from 'react-native';

/**
 * Read a picture's pixel size.
 *
 * On web, measure with the browser image. React Native Web's `Image.getSize`
 * waits on `decode()` and can leave the viewer on a spinner.
 */
export function measureImage(
  uri: string,
  onSize: (width: number, height: number) => void,
  onFail: () => void,
): void {
  if (Platform.OS === 'web' && measureWithBrowserImage(uri, onSize, onFail)) {
    return;
  }
  if (typeof Image.getSize !== 'function') {
    onFail();
    return;
  }
  Image.getSize(uri, onSize, onFail);
}

function measureWithBrowserImage(
  uri: string,
  onSize: (width: number, height: number) => void,
  onFail: () => void,
): boolean {
  if (typeof window === 'undefined' || typeof window.Image !== 'function') {
    return false;
  }
  const img = new window.Image();
  img.onload = () => {
    if (img.naturalWidth > 0 && img.naturalHeight > 0) {
      onSize(img.naturalWidth, img.naturalHeight);
      return;
    }
    onFail();
  };
  img.onerror = () => onFail();
  img.src = uri;
  return true;
}
